/**
 * Subscription Cancel Page
 * Shown when user cancels Stripe checkout
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';

const SubscriptionCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#050810] flex items-center justify-center">
      <div className="bg-[#131b2e] rounded-2xl p-8 max-w-md w-full mx-4 text-center border border-[#1e2a45]">
        <XCircle className="h-16 w-16 text-[#F97316] mx-auto mb-4" />
        <h2 className="text-xl font-bold text-white mb-2">Subscription Cancelled</h2>
        <p className="text-gray-400 mb-6">
          No worries! You can still browse all markets and view prices for free.
          Subscribe anytime to start trading with mock tokens.
        </p>
        <button
          onClick={() => navigate('/')}
          className="px-6 py-2 bg-[#3B82F6] text-white rounded-full hover:bg-[#2563EB] transition-colors"
        >
          Return Home
        </button>
      </div>
    </div>
  );
};

export default SubscriptionCancel;
